import { getStreamId } from './helpers';
export const reduxKey = '@@collectionPopup';
export const actionKey = '@@COLLECTION_POPUP';
export const PRIVATE_COLLECTIONS_STREAMID = getStreamId(true);
export const PUBLIC_COLLECTIONS_STREAMID = getStreamId(false);
export const COLLECTIONS_PAGE_SIZE = 20;
export const UNDO_TIMEOUT = 5000;

//# sourceMappingURL=constants.js.map